export default "__VITE_ASSET__d4ebbb0e__"